import { TranslateService } from "@ngx-translate/core";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { QuestionField } from "@zp-models/question-field";

/**
 * Builds the i18n key for an option label
 */
function buildLabelKey(field: QuestionField, optionValue: string, questionId?: string): string {
  const key = `WIZARD_STEPS.${questionId?.toUpperCase()}.FIELDS.${field.name.toUpperCase()}.OPTIONS.${optionValue.toUpperCase()}.LABEL`;
  return key;
}

/**
 * Returns translated labels for form options as a map.
 */
export function getTranslatedOptionsMap(
  field: QuestionField,
  translate: TranslateService,
  questionId?: string
): Observable<{ value: string; label: string; helpText?: string }[]> {
  if (!field.options || field.options.length === 0) {
    console.warn("[getTranslatedOptionsMap] No options provided for field:", field.name);
    return of([]);
  }

  const labelKeys = field.options.map((opt) =>
    opt.label?.startsWith("WIZARD_STEPS.") ? opt.label : buildLabelKey(field, opt.value, questionId)
  );

  const helpTextKeys = field.options.map(
    (opt) =>
      `WIZARD_STEPS.${questionId?.toUpperCase()}.FIELDS.${field.name.toUpperCase()}.OPTIONS.${opt.value.toUpperCase()}.SUBLABEL`
  );

  const allKeys = [...labelKeys, ...helpTextKeys];

  return translate.get(allKeys).pipe(
    map((translations) => {
      return field.options!.map((opt, idx) => {
        const labelKey = labelKeys[idx];
        const helpTextKey = helpTextKeys[idx];

        return {
          value: opt.value,
          label: translations[labelKey] || opt.value,
          helpText: translations[helpTextKey] || undefined,
        };
      });
    })
  );
}
